import React, { useState } from 'react';

import styles from '../../assets/styles/AppHome/Sidebar.module.scss';
import MediaQuery, { useMediaQuery } from 'react-responsive';
import Logo from '../../assets/img/Mima-light-logo.png';
import { useNavigate } from 'react-router-dom';
import { SidebarData as MainSidebarData, ExpiredSidebarData } from './SidebarData';
import { businessStore, userStore } from '../../stores';
import { FaBars } from 'react-icons/fa';
import { observer } from 'mobx-react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import AppDLBanner from '../AppDLBanner';


const Sidebar = () => {

	const [expandedNav, setExpandedNav] = useState(-1);

	const { user } = userStore;
	const userPermissions = new Set(
		user?.permissions?.map(perm => perm.module) || []
	);
	const permissionArray = Array.from(userPermissions)
	const [mini, setMini] = useState(true);

	const navigate = useNavigate();

	const isBelow1000 = useMediaQuery({
		query: '(max-width: 1000px)',
	});

	const minSidebar = () => {
		setMini(!mini);
	};

	const SidebarData = businessStore.expiredSubscription ? ExpiredSidebarData : MainSidebarData

	const filteredSidebarData = SidebarData.filter(item => {
		if (permissionArray.includes(item.module)) {
			return true;
		}

		if (item.subNav) {
			const matchingSubNavItem = item.subNav.find(subNavItem => permissionArray.includes(subNavItem.module));
			if (matchingSubNavItem) {
				return true;
			}
		}

		return !item.module && !item.subNav;
	});

	//for App dl banner	
	const [appLink, setAppLink] = useState(true);
	const hasMobileApp = userStore?.hasMobileApp;


	return (
		<MediaQuery minWidth={1000}>
			<div className={`${mini && !isBelow1000 ? styles.sb : styles.sb__min}`}>
				<div
					className={`${mini && !isBelow1000 ? styles.sb_title : styles.sb__min_title
						}`}
				>
					<FaBars
						className={`${mini && !isBelow1000 ? styles.sb_icon : styles.sb__min_icon
							}`}
					/>
					<img
						src={Logo}
						className={`${mini && !isBelow1000 ? styles.sb_logo : styles.sb__min_logo
							}`}
						alt="Mima logo"
					/>
				</div>
				<nav className={((appLink && !hasMobileApp) || !hasMobileApp) ? styles.sb_nav : styles.sb_nav_2}>
					<ul
						className={`${mini && !isBelow1000 ? styles.sb_nav_ul : styles.sb__min_nav_ul
							}`}
					>
						{filteredSidebarData.map((item, index) => {
							return (
								<li
									key={index}
									className={`${styles.sb_nav_item} ${window.location.pathname === item.link
										? styles.sb_nav_item_active
										: ''
										}`}

									onClick={() => {
										if (item.subNav !== undefined) {
											if (expandedNav === index) {
												setExpandedNav(-1);
											} else {
												setExpandedNav(index);
											}
										} else {
											navigate(item.link);
										};
									}}

								>
									{(!item.module && user.accountType === 'Business') ||
										userPermissions.has(item.module) ||
										(item.type === 'GENERAL' &&
											user.accountType === 'Employee') ? (
										<>
											<div className={styles.sb_nav_link} key={item.title}>
												<span className={styles.sb_nav_link_icon}>
													{item.icon}
												</span>
												<span
													className={`${mini && !isBelow1000
														? null
														: styles.sb__min_nav_link_text
														}`}
												>
													{item.title}
												</span>
												{mini && !isBelow1000 && item.subNav !== undefined && <MdOutlineKeyboardArrowDown
													className={expandedNav === index ? styles.sb_nav_link_arr : styles.sb_nav_link_arr_1} />}
											</div>
											{expandedNav === index && item.subNav !== undefined && (
												<ul className={styles.subNav_ul}>

													{item.subNav.filter((x) => {
														return permissionArray.includes(x.module) || x.module === undefined
													}).map((x, i) => (
														<li
															className={`${styles.subNav_li} ${window.location.pathname === x.link
																? styles.subNav_li_active
																: ''
																}`}
															key={i}
															onClick={() => {
																setExpandedNav(-1);
																// menuClicked();
																navigate(x.link);
															}}
														>
															{(!x.module && user.accountType === 'Business') ||
																userPermissions.has(x.module) ||
																(x.type === 'GENERAL' &&
																	user.accountType === 'Employee') ? (
																<>
																	<div className={styles.sb_nav_link} key={x.title}>
																		<span className={styles.sb_nav_link_icon}>
																			{x.icon}
																		</span>
																		<span
																			className={`${mini && !isBelow1000
																				? null
																				: styles.sb__min_nav_link_text
																				}`}
																		>
																			{x.title}
																		</span>

																	</div>
																</>) : ("")}
														</li>
													))}

												</ul>
											)}
										</>

									) : (
										''
									)}
								</li>
							);
						})}
					</ul>
				</nav>
				<AppDLBanner
					appLink={appLink}
					setAppLink={setAppLink}
					hasMobileApp={hasMobileApp}
				/>
			</div>
		</MediaQuery>
	);
};

export const MobileSidebar = ({ mobileMenu }) => {
	const [expandedNav, setExpandedNav] = useState(-1);
	const SidebarData = businessStore.expiredSubscription ? ExpiredSidebarData : MainSidebarData
	const navigate = useNavigate();
	const { user } = userStore;
	const userPermissions = new Set(
		user?.permissions?.map(perm => perm.module) || []
	);
	const permissionArray = Array.from(userPermissions)

	const filteredSidebarData = SidebarData.filter(item => {
		if (permissionArray.includes(item.module)) {
			return true;
		}

		if (item.subNav) {
			const matchingSubNavItem = item.subNav.find(subNavItem => permissionArray.includes(subNavItem.module));
			if (matchingSubNavItem) {
				return true;
			}
		}

		return !item.module && !item.subNav;
	});

	//for App dl banner	
	const [appLink, setAppLink] = useState(true);
	const hasMobileApp = userStore?.hasMobileApp;

	return (
		<div className={styles.sb}>
			<div className={styles.sb_title}>
				<FaBars className={styles.sb_icon} onClick={mobileMenu} />
				<img src={Logo} className={styles.sb_logo} alt="Mima logo" />
			</div>
			<nav className={((appLink && !hasMobileApp) || !hasMobileApp) ? styles.sb_nav : styles.sb_nav_2}>
				<ul className={styles.sb_nav_ul}>
					{filteredSidebarData.map((item, index) => {
						return (
							<li
								key={index}
								className={`${styles.sb_nav_item} ${window.location.pathname === item.link
									? styles.sb_nav_item_active
									: ''
									}`}
								onClick={() => {
									if (item.subNav !== undefined) {
										if (expandedNav === index) {
											setExpandedNav(-1);
										} else {
											setExpandedNav(index);
										}
									} else {
										navigate(item.link);
									}
								}}
							>
								{(!item.module && user.accountType === 'Business') ||
									userPermissions.has(item.module) ||
									(item.type === 'GENERAL' && user.accountType === 'Employee') ? (
									<>
										<div className={styles.sb_navItem}>
											<div className={styles.sb_nav_link}>
												<span className={styles.sb_nav_link_icon}>{item.icon}</span>
												<span className={styles.sb_nav_link_text}>
													{item.title}
												</span>

											</div>
											{item.subNav !== undefined && <MdOutlineKeyboardArrowDown
												className={expandedNav === index ? styles.sb_nav_link_arr : styles.sb_nav_link_arr_1} />}

										</div>
										{expandedNav === index && item.subNav !== undefined && (
											<ul className={styles.subNav_ul}>
												{item.subNav.filter((x) => {
													return permissionArray.includes(x.module) || x.module === undefined
												}).map((x, i) => (
													<li
														className={`${styles.subNav_li} ${window.location.pathname === x.link
															? styles.subNav_li_active
															: ''
															}`}
														key={i}
														onClick={() => {
															setExpandedNav(-1);
															// menuClicked();
															navigate(x.link);
														}}
													>
														{(!x.module && user.accountType === 'Business') ||
															userPermissions.has(x.module) ||
															(x.type === 'GENERAL' &&
																user.accountType === 'Employee') ? (
															<>
																<div className={styles.sb_nav_link} key={item.title}>
																	<span className={styles.sb_nav_link_icon}>
																		{x.icon}
																	</span>
																	<span>
																		{x.title}
																	</span>

																</div>
															</>) : ("")}
													</li>
												))}

											</ul>
										)}
									</>


								) : (
									''
								)}
							</li>
						);
					})}
				</ul>
			</nav>
			<AppDLBanner
				appLink={appLink}
				setAppLink={setAppLink}
				hasMobileApp={hasMobileApp}
			/>
		</div>
	);
};

export default observer(Sidebar);
